import React, { Component } from 'react';
import PropTypes from 'prop-types';
import KuposSelectBox from './KuposSelectBox';
import KuposDatePicker from './KuposDatePicker';
import DateService from '../../services/dateService';
import KuposCounter from './KuposCounter';
import KuposTimePicker from './KuposTimePicker';
import KuposInput from './KuposInput';
import { KuposAtCounter, KuposDateTimePicker } from '.';
import KuposHybridInput from './KuposHybridInput';

export default class NewSearchBoxTransfer extends Component {
  static propTypes = {
    cities: PropTypes.array,
    openNewSearch: PropTypes.bool,
    newSearchTransfer: PropTypes.object,
    newSearch: PropTypes.func,
    onChange: PropTypes.func,
    t: PropTypes.func,
  };
  constructor(props) {
    super(props);
    this.selectServiceOptions = [
      { value: 1, label: 'HOME.TO_AT' },
      { value: 2, label: 'HOME.FROM_AT' },
    ];
    this.state = {
      key: 1,
      // atOriginText: this.props.transferData.selectedOrigin
      //   ? this.props.transferData.selectedOrigin.address
      //   : '',
      // atDestinationText: this.props.transferData.selectedDestination
      //   ? this.props.transferData.selectedDestination.address
      //   : '',
    };
    this.textInput = React.createRef();
  }

  componentDidMount() {
    let transferdata = JSON.parse(sessionStorage.getItem('transferData'));

    console.log('Initial Transfer data is-----', transferdata);

    // if (this.state.atOriginText || this.state.atDestinationText) {
    //   this.setState(prevState => ({ airportChoosen: true }));
    // }

    if (
      this.props.transferData.selectedOrigin &&
      this.props.transferData.selectedOrigin.airport_name
    ) {
      this.setState({
        key: this.state.key + 1,
        atOriginText: this.props.transferData.selectedOrigin
          ? this.props.transferData.selectedOrigin.airport_name
          : '',
        originIsAirport: true,
        airportChoosen: true,
        // showOriginTerminalSuggestions: true,
      });
    } else {
      this.setState({
        key: this.state.key + 1,
        atOriginText: this.props.transferData.selectedOrigin
          ? this.props.transferData.selectedOrigin.address
          : '',
        originIsAirport: false,
        // airportChoosen: true,
        // showOriginTerminalSuggestions: false,
      });
    }

    if (
      this.props.transferData.selectedDestination &&
      this.props.transferData.selectedDestination.airport_name
    ) {
      this.setState({
        atDestinationText: this.props.transferData.selectedDestination
          ? this.props.transferData.selectedDestination.airport_name
          : '',
        destIsAirport: true,
        // showDestinationTerminalSuggestions: true,
      });
    } else {
      this.setState({
        atDestinationText: this.props.transferData.selectedDestination
          ? this.props.transferData.selectedDestination.address
          : '',
        destIsAirport: false,
        // showDestinationTerminalSuggestions: false,
      });
    }

    if (transferdata && transferdata.selectedOrigin && transferdata.selectedOrigin.airport_name) {
      this.setState({
        originIsAirport: true,
      });
    } else {
      this.setState({
        originIsAirport: false,
      });
    }

    if (transferdata && transferdata.selectedDestination && transferdata.selectedDestination.airport_name) {
      this.setState({
        destIsAirport: true,
      });
    } else {
      this.setState({
        destIsAirport: false,
      });
    }

    // this.setState({
    //   key: this.state.key + 1,
    //   atOriginText: this.props.transferData.selectedOrigin
    //     ? this.props.transferData.selectedOrigin.address
    //     : '',
    //   atDestinationText: this.props.transferData.selectedDestination
    //     ? this.props.transferData.selectedDestination.address
    //     : '',
    //   selectedStartDate: this.props.transferData.selectedStartDate,
    //   selectedEndDate: this.props.transferData.selectedEndDate,
    // });
  }

  componentDidUpdate(prevProps) {
    // if (
    //   prevProps.transferData.selectedOrigin &&
    //   prevProps.transferData.selectedOrigin.address !==
    //     this.props.transferData.selectedOrigin.address
    // ) {
    //   this.setState({
    //     atOriginText: this.props.transferData.selectedOrigin
    //       ? this.props.transferData.selectedOrigin.address
    //       : '',
    //     atDestinationText: this.props.transferData.selectedDestination
    //       ? this.props.transferData.selectedDestination.address
    //       : '',
    //   });
    // }
  }

  search = () => {
    console.log('Props in transferdata on new search-------', this.props.home.atBlockTime[0].value);
    let errorCount = 0;
    if (!this.props.transferData.selectedOrigin) {
      this.setState({ transferSourceCityError: 'VALIDATIONS.VALID_ORIGIN_CITY' });
      errorCount++;
      return;
    }

    if (
      !this.props.transferData.selectedDestination ||
      this.props.transferData.selectedDestination === ''
    ) {
      this.setState({ transferDestinationCityError: 'VALIDATIONS.VALID_DESTINATION_CITY' });
      errorCount++;

      return;
    }

    let selectedStartDate = new Date(
      DateService.changeDateFormat(
        this.props.transferData.selectedStartDate,
        'dd-mm-yyyy',
        'yyyy-mm-dd',
      ) +
        'T' +
        this.props.transferData.selectedStartTime,
    );
    var currentDate = new Date();
    var currentDateUtc4Hours =
      currentDate.getTime() + 1000 * Number(this.props.home.atBlockTime[0].value);

    if (
      selectedStartDate.getTime() < currentDateUtc4Hours
      // selectedStartDate.getTime() < currentDate.getTime()
      // + (this.props.transferData.selectedService.value === 2 ? 0 : 1000 * 60 * 60 * 3)
    ) {
      this.setState({
        transferDateTimeError: 'VALIDATIONS.VALID_LESS_TIME',
      });
      return;
    }
    this.props.newSearch();
  };

  swapCities = () => {
    this.props.swapCities();
    this.setState({ key: this.state.key + 1 });
  };

  onChange = (val, type) => {
    // console.log('+++ type and value in search page', val, type);
    this.setState({
      transferTimeError: null,
    });

    if (type === 'origin') {
      this.setState({ transferSourceCityError: null });
    } else if (type === 'destination') {
      this.setState({ transferDestinationCityError: null });
    } else if (type === 'start_date' || type === 'start_time') {
      this.setState({ transferDateTimeError: null });
    }
    this.props.onChange(val, type);
  };

  eraseSelectedInput = type => {
    let val = '';
    switch (type) {
      case 'origin':
        this.setState({ atOrignText: val });
        this.props.onChange(val, 'origin');
        break;
      case 'destination':
        this.setState({ atDestinationText: val });
        this.props.onChange(val, 'destination');
        break;
    }
  };

  clearDateTime = () => {
    this.props.onChange(null, 'end_date');
    this.props.onChange(null, 'end_time');
  };

  onATInputBlur = (val, type) => {
    // console.log('On Blur at input', val);
    //

    setTimeout(() => {
      if (type === 'origin') {
        this.setState({
          showOriginTerminalSuggestions: false,
          // showDestinationTerminalSuggestions: false,
        });
      } else {
        this.setState({
          showDestinationTerminalSuggestions: false,
          // showOriginTerminalSuggestions: false,
        });
      }
    }, 300);
  };

  onATInputFocus = type => {
    if (type === 'origin')
      this.setState({
        showOriginTerminalSuggestions: true,
        originType: this.state.setPickupTerminal ? 'text' : 'places',
      });
    else if (type === 'destination')
      this.setState({
        showDestinationTerminalSuggestions: true,
        destinationType: this.state.setDestinationTerminal ? 'text' : 'places',
      });
  };

  onSelect = (val, type) => {
    console.log('At terminal clicked----', val);

    if (type === 'origin') {
      console.log('setting origin');
      this.setState({
        showOriginTerminalSuggestions: false,
        setPickupTerminal: val,
        airportChoosen: true,
        atOrignText: val.airport_name,
        originType: 'text',
      });

      // this.props.onTransferChange(val, 'origin');
      this.props.onChange(val, 'origin');
    } else {
      console.log('setting destination');
      this.setState({
        showDestinationTerminalSuggestions: false,
        setDestinationTerminal: val,
        atDestinationText: val.airport_name,
        destinationType: 'text',
        airportChoosen: true,
      });
      // this.props.onTransferChange(val, 'destination');
      this.props.onChange(val, 'destination');
    }
  };

  renderATTerminals = (val, key, type) => {
    console.log('terminal to render is---', val, type);
    return (
      <div onClick={() => this.onSelect(val, type)}>
        <a key={key} className="at-terminal-item">
          {/* <img src="/static/images/icons/home/airport-icon.png" /> */}
          {val.airport_name}
        </a>
      </div>
    );
  };

  render() {
    const { t } = this.props;

    // console.log('state in new search bar transfer-----', this.state);
    // console.log('NEW SEARCH BOX TRANSFER PROPS ARE ttttttt------=', this.props);

    return (
      <div className={'common-new-search-box ' + (this.props.openNewSearch ? 'open' : '')}>
        <div
          className={
            ' content-container new-search-box home-selection-input-boxes  ' + this.props.widthClass
          }
          style={{
            width: `${this.props.searchBoxWidth}!important`,
            alignItems: this.props.alignItems,
          }}
        >
          <div className="home-selection-input-box font10 flex4" style={{ position: 'relative' }}>
            <span className="label font10">{t('HOME.ORIGIN')}</span>
            <KuposHybridInput
              type={this.state.originType}
              // type="places"
              value={this.state.atOriginText}
              onTextChange={val =>
                this.setState({
                  showOriginTerminalSuggestions: val ? false : true,
                  atOriginText: val,
                })
              }
              onChange={val => this.onChange(val, 'origin')}
              placeholder={t('HOME.ORIGIN')}
              icon="/static/images/icons/home/icon_source.png"
              height={40}
              fontSize="font9"
              error={this.state.transferSourceCityError ? true : false}
              errorMessage={this.props.t(this.state.transferSourceCityError)}
              erasable={true}
              eraseSelectedInput={() => this.eraseSelectedInput('origin')}
              onBlur={val => this.onATInputBlur(val, 'origin')}
              onFocus={() => this.onATInputFocus('origin')}
              t={t}
            />

            {this.props.home.atTerminals &&
              this.state.showOriginTerminalSuggestions &&
              !this.state.airportChoosen && (
                <div className="at-termninal-suggestions auto-suggestions font10 scroll-style">
                  {this.props.home.atTerminals &&
                    this.props.home.atTerminals.map((val, key) => {
                      return this.renderATTerminals(val, key, 'origin');
                    })}
                </div>
              )}
          </div>

          <div className="home-selection-input-box font10 flex4" style={{ position: 'relative' }}>
            <span className="label font10">{t('HOME.DESTINATION')}</span>
            <KuposHybridInput
              type={this.state.destinationType}
              // type="places"
              value={this.state.atDestinationText}
              onTextChange={val =>
                this.setState({
                  showDestinationTerminalSuggestions: val ? false : true,
                  atDestinationText: val,
                })
              }
              onChange={val => this.onChange(val, 'destination')}
              placeholder={t('HOME.DESTINATION')}
              icon="/static/images/icons/home/icon_source2.png"
              height={40}
              fontSize="font9"
              error={this.state.transferDestinationCityError ? true : false}
              errorMessage={this.props.t(this.state.transferDestinationCityError)}
              erasable={true}
              eraseSelectedInput={() => this.eraseSelectedInput('destination')}
              onBlur={val => this.onATInputBlur(val, 'destination')}
              onFocus={() => this.onATInputFocus('destination')}
              // key={this.state.key}
              t={t}
            />

            {this.props.home.atTerminals &&
              this.state.showDestinationTerminalSuggestions &&
              !this.state.airportChoosen && (
                <div className="at-termninal-suggestions auto-suggestions font10 scroll-style">
                  {this.props.home.atTerminals &&
                    this.props.home.atTerminals.map((val, key) => {
                      return this.renderATTerminals(val, key, 'destination');
                    })}
                </div>
              )}
          </div>

          <div className="home-selection-input-box font10 datebox date-time-box">
            <span className="label font11">{t('HOME.ONE_WAY')}</span>
            <KuposDateTimePicker
              onDateChange={val => this.onChange(val, 'start_date')}
              onTimeChange={val => this.onChange(val, 'start_time')}
              selectedDate={this.props.transferData.selectedStartDate}
              selectedTime={this.props.transferData.selectedStartTime}
              t={t}
              transferData={this.props.transferData}
              showTimeInitially={true}
              error={this.state.transferDateTimeError ? true : false}
              errorMessage={this.props.t(this.state.transferDateTimeError)}
            />
          </div>

          <div className="home-selection-input-box font10 datebox date-time-box">
            <span className="label font11">{t('HOME.ROUND_TRIP')}</span>

            <KuposDateTimePicker
              onDateChange={val => this.onChange(val, 'end_date')}
              onTimeChange={val => this.onChange(val, 'end_time')}
              selectedDate={this.props.transferData.selectedEndDate}
              selectedTime={this.props.transferData.selectedEndTime}
              minDate={this.props.transferData.selectedStartDate}
              optional={this.props.transferData.selectedEndDate ? false : true}
              disabled={true}
              optionalDatePicker={true}
              clearDateTime={() => this.clearDateTime()}
              t={t}
              transferData={this.props.transferData}
              showTimeInitially={true}
              error={this.state.transferDateTimeErrorReturn ? true : false}
              errorMessage={this.props.t(this.state.transferDateTimeErrorReturn)}
            />
          </div>

          {/* <div className="home-selection-input-box  font10 flex2">
            <span className="label font10">{t('HOME.KUPOS')}</span>
            <KuposCounter
              value={this.props.transferData.selectedKupos}
              onChange={val => this.onChange(val, 'kupos')}
            />
          </div> */}

          <div className="home-selection-input-box font10 counter">
            <span className="label font11">{t('HOME.KUPOS')}</span>
            {/* <KuposCounter
            value={this.props.transferData.selectedKupos}
            error={this.state.transferKuposError ? true : false}
            errorMessage={this.state.transferKuposError}
            onChange={val => this.onTransferChange(val, 'kupos')}
          /> */}
            <div
              className="show-count"
              onClick={() => this.setState({ showAtCounter: !this.state.showAtCounter })}
            >
              <div>
                <img
                  className="at-count-user-icon"
                  src="/static/images/kupos-AirportTransfer-Icon-Userkupos.svg"
                />
              </div>
              <div>
                <span className="font9">
                  {this.props.transferData && Number(this.props.transferData.selectedKupos)}
                  {/* &nbsp;Pasajero */}
                </span>
              </div>
              <div>
                <img
                  className="at-count-down-icon"
                  src="/static/images/kupos-AirportTransfer-Icon-Arrow.svg"
                />
              </div>
            </div>

            {this.state.showAtCounter ? (
              <div
                className="at-counter-popoup"
                onMouseLeave={() => this.setState({ showAtCounter: false })}
              >
                <KuposAtCounter
                  selectedKupos={
                    this.props.transferData.selectedAdultKupos
                      ? this.props.transferData.selectedAdultKupos
                      : 0
                  }
                  onTransferChange={val => this.onChange(val, 'kupos_adult')}
                  kuposType={'kupos_adult'}
                  borderBottom
                  seatInfo={this.props.seatTypes ? this.props.seatTypes[0] : ''}
                />

                <KuposAtCounter
                  selectedKupos={
                    this.props.transferData.selectedKidKupos
                      ? this.props.transferData.selectedKidKupos
                      : 0
                  }
                  onTransferChange={val => this.onChange(val, 'kupos_kid')}
                  kuposType={'kupos_kid'}
                  borderBottom
                  seatInfo={this.props.seatTypes ? this.props.seatTypes[1] : ''}
                />

                <KuposAtCounter
                  selectedKupos={
                    this.props.transferData.selectedInfantKupos
                      ? this.props.transferData.selectedInfantKupos
                      : 0
                  }
                  onTransferChange={val => this.onChange(val, 'kupos_infant')}
                  kuposType={'kupos_infant'}
                  seatInfo={this.props.seatTypes ? this.props.seatTypes[2] : ''}
                />
              </div>
            ) : null}
          </div>

          <div
            className="home-selection-input-box datebox font10 flex2 search-button-box-at"
            style={{ paddingTop: 22 }}
          >
            <button className="kupos-button home-selection-input-button " onClick={this.search}>
              <img
                style={{ marginRight: 0 }}
                className="icon-size"
                src="/static/images/icons/home/next-arrow.png"
                alt={this.props.t('TRANSLATIONS.ICON_SEARCH_WHITE')}
              />{' '}
              {/* <span className="font11">{t('HOME.SEARCH')}</span> */}
            </button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/NewSearchBoxTransfer.js